'use strict';
angular.module('resourceCenterMaterialModule').directive('selectNav', [
    '$state',
    'mrApiService',
    'materialConst',
    function($state, mrApiService, materialConst) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './resourceCenter/materialResource/directive/initSelectNav/index.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        themeDataList: [],
                        statusList: [],
                        durationList: [],
                        bitRateList: [],
                        copyrightList: [],
                        commonListStart: [
                            // {
                            //     name: '分类', // 选择分类名称
                            //     value: 'id', // 给后台的取值字段 默认value
                            //     arrName: 'themeDataList', // 数组名称
                            //     selectName: 'zyzxField', // 后台的传值自读
                            //     showName: 'dictName', // 每一个分类项名称 默认name
                            // },
                            {
                                name: '状态',
                                arrName: 'statusList',
                                selectName: 'checkStatus',
                            },
                        ],
                        commonListEnd: [
                            {
                                name: '版权',
                                arrName: 'copyrightList',
                                selectName: 'isOriginal',
                            },
                        ],
                        resourceType: {
                            '2': [
                                {
                                    name: '时长',
                                    arrName: 'durationList',
                                    selectName: 'resourceDuration',
                                },
                                {
                                    name: '码率',
                                    arrName: 'bitRateList',
                                    selectName: 'resourceBitRate',
                                },
                            ],
                            '1': [
                                {
                                    name: '时长',
                                    arrName: 'durationList',
                                    selectName: 'resourceDuration',
                                },
                            ],
                            '0': [
                                {
                                    name: '类型',
                                    arrName: 'imgTypeList',
                                    selectName: 'pictureType',
                                },
                                {
                                    name: '大小',
                                    arrName: 'sizeList',
                                    selectName: 'pictureSize',
                                },
                            ],
                        },
                    };
                }

                /**
                 * [initData description] 初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    // getThemeData();
                    $scope.data.statusList = materialConst.statusType;
                    $scope.data.durationList = materialConst.materialDuration;
                    $scope.data.bitRateList = materialConst.bitRate;
                    $scope.data.copyrightList = materialConst.versionInfo;
                    $scope.data.imgTypeList = materialConst.imgType;
                    $scope.data.sizeList = materialConst.imgSize;
                    $scope.typeAuthorityList = $scope.data.commonListStart.concat(
                        $scope.data.resourceType[$state.params.resourcetype || $scope.resourceType],
                        $scope.data.commonListEnd
                    );
                }

                /**
                 * [getThemeData description] 获取主题分类数据
                 * @return  {[type]}  [return description]
                 */
                function getThemeData() {
                    mrApiService.getThemeData().then(function(data) {
                        $scope.data.themeDataList = [
                            {
                                dictName: '全部',
                                id: '',
                            },
                        ].concat(data);
                    });
                }

                /**
                 * [changeSelect description] 选择过滤条件后的回调函数
                 * @param   {[type]}  type  [type description] 分类信息
                 * @param   {[type]}  item  [item description] 过滤项的对象信息
                 * @return  {[type]}        [return description]
                 */
                $scope.changeSelect = function(type, item) {
                    $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = 1;
                    $scope.basicalStatus.searchParams[type.selectName] = item[type.value || 'value'];
                    $scope.basicalStatus.isWithFilters = true;
                    $scope.requestData();
                };
            },
        };
    },
]);
